export interface DynamicQueueVoiceDefinition {
  queueId: number;
  voiceText: any;
  voiceLabel: any;
}

export function walkScreenItems(
  screenItems: any[],
  visit: (item: any) => void
): void {
  if (!Array.isArray(screenItems)) return;
  for (const item of screenItems) {
    if (item?.type === "zone" && Array.isArray(item.children)) {
      walkScreenItems(item.children, visit);
    } else if (item?.type !== "zone") {
      visit(item);
    }
  }
}

export function collectQueueAppItems(screenItems: any[]): any[] {
  const queueItems: any[] = [];
  walkScreenItems(screenItems, (item) => {
    if (item?.type === "app" && item?.appType === "queue") {
      queueItems.push(item);
    }
  });
  return queueItems;
}

export function getQueueIdsFromQueueConfig(queueConfig: any): number[] {
  const queues = queueConfig?.queues;
  if (Array.isArray(queues) && queues.length > 0) {
    return queues
      .map((id: any) => Number(id))
      .filter((id) => !Number.isNaN(id));
  }
  const queueId = queueConfig?.queueId;
  if (queueId !== undefined && queueId !== null && queueId !== "") {
    const id = Number(queueId);
    return Number.isNaN(id) ? [] : [id];
  }
  return [];
}

function parseCustomVoiceCounter(
  raw: any
): Array<{ queueId: number; language: string; voiceText: string; voiceLabel: string }> {
  if (!raw || raw === "[]" || raw === "null") return [];
  const callData =
    typeof raw === "string" ? JSON.parse(raw || "[]") : raw || [];
  return Array.isArray(callData) ? callData : [];
}

/** Per-queue voice definitions from dynamic screen queue widgets. */
export function collectDynamicQueueVoiceDefinitions(
  configScreen: any,
  language: string
): DynamicQueueVoiceDefinition[] {
  if (!configScreen?.items) return [];

  const definitions: DynamicQueueVoiceDefinition[] = [];
  const seenQueueIds = new Set<number>();

  collectQueueAppItems(configScreen.items).forEach((item) => {
    const qc = item.queueConfig || {};
    const queueIds = getQueueIdsFromQueueConfig(qc);
    if (!queueIds.length) return;

    const customEntries = parseCustomVoiceCounter(qc.customVoiceCounter);
    const langEntry = customEntries.find(
      (entry) => entry.language === language && queueIds.includes(Number(entry.queueId))
    );

    let voiceText: string | null = null;
    let voiceLabel: string | null = null;

    if (langEntry?.voiceText) {
      voiceText = langEntry.voiceText;
      voiceLabel = langEntry.voiceLabel || langEntry.voiceText;
    } else {
      const voiceCall = qc.voice_call ?? item.voice_call;
      if (voiceCall == 1) {
        voiceText = qc.voiceCounter ?? item.voiceCounter ?? null;
        voiceLabel =
          qc.textCounter ?? item.textCounter ?? voiceText ?? null;
      }
    }

    if (!voiceText) return;

    queueIds.forEach((queueId) => {
      if (seenQueueIds.has(queueId)) return;
      seenQueueIds.add(queueId);
      definitions.push({
        queueId,
        voiceText,
        voiceLabel: voiceLabel || voiceText,
      });
    });
  });

  return definitions;
}

export function findQueueAppForLineId(
  screenItems: any[],
  queueLineId: number
): any | undefined {
  return collectQueueAppItems(screenItems).find((item) => {
    const ids = getQueueIdsFromQueueConfig(item.queueConfig || {});
    return ids.includes(Number(queueLineId));
  });
}
